import { render, staticRenderFns } from "./LmPeopleNewOrEdit.vue?vue&type=template&id=619bb6df"
import script from "./LmPeopleNewOrEdit.vue?vue&type=script&lang=js"
export * from "./LmPeopleNewOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports